/* tq-lineup · shape filter, arrows, and the view strip on each card. */
(() => {
  document.querySelectorAll('[data-tq-lineup]').forEach((root) => {
    const rail = root.querySelector('[data-tq-rail]');
    const cards = [...root.querySelectorAll('.tq-card')];
    const prev = root.querySelector('[data-tq-prev]');
    const next = root.querySelector('[data-tq-next]');

    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
      if (!root.classList.contains('tq-lineup--grid')) root.classList.toggle('is-static', max <= 2);
    };
    const step = () => {
      const card = cards.find((c) => !c.hidden);
      return card ? card.getBoundingClientRect().width + 24 : 400;
    };
    prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    root.querySelectorAll('[data-filter]').forEach((chip) => {
      chip.addEventListener('click', () => {
        root.querySelectorAll('[data-filter]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        const f = chip.dataset.filter;
        cards.forEach((card) => { card.hidden = f !== 'all' && card.dataset.shape !== f; });
        rail.scrollTo({ left: 0 });
        update();
      });
    });

    /* View strip: swap the main photo. Once a view other than the stock one is
       picked, hover stops covering it with the on course photo. */
    cards.forEach((card) => {
      const main = card.querySelector('[data-tq-main]');
      const views = [...card.querySelectorAll('.tq-card__view')];
      views.forEach((v, i) => v.addEventListener('click', (e) => {
        e.preventDefault();
        if (v.getAttribute('aria-pressed') === 'true') return;
        views.forEach((o) => o.setAttribute('aria-pressed', String(o === v)));
        card.classList.toggle('is-viewing', i !== 0);
        main.classList.add('is-swapping');
        const img = new Image();
        img.onload = () => {
          main.src = v.dataset.src;
          main.alt = v.dataset.alt;
          requestAnimationFrame(() => main.classList.remove('is-swapping'));
        };
        img.src = v.dataset.src;
      }));
    });
    update();
  });
})();
